import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import BottomTabNavigation from '../../components/ui/BottomTabNavigation';
import CategoryFilter from '../../components/ui/CategoryFilter';
import VendorDetailModal from '../../components/ui/VendorDetailModal';
import HeroSlider from './components/HeroSlider';
import LocationSelector from './components/LocationSelector';
import TrendingSection from './components/TrendingSection';

const HomeScreen = () => {
    const navigate = useNavigate();
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const servicesData = [
        {
            id: 1,
            name: "Pixel Perfect Studios",
            category: "Photography",
            rating: 4.9,
            reviewsCount: 156,
            price: 25000,
            image: "https://images.unsplash.com/photo-1522922318641-f0272c6d2e21",
            imageAlt: "Professional photographer with DSLR camera capturing wedding moments outdoors with natural lighting and bokeh background",
            description: "Award-winning wedding photography with cinematic storytelling. We specialize in candid moments and artistic compositions that capture the essence of your special day.",
            location: "Bandra West",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543210",
            email: "contact@pixelperfect.com",
            services: ["Wedding Photography", "Pre-Wedding Shoots", "Candid Photography", "Drone Coverage", "Photo Albums"],
            reviews: [
                {
                    author: "Priya Sharma",
                    rating: 5,
                    comment: "Absolutely stunning work! They captured every emotion perfectly. Highly recommended for weddings.",
                    date: "January 15, 2026"
                },
                {
                    author: "Rahul Mehta",
                    rating: 5,
                    comment: "Professional team with creative vision. Our wedding photos exceeded all expectations.",
                    date: "December 28, 2025"
                }]

        },
        {
            id: 2,
            name: "Royal Tent House",
            category: "Tent House",
            rating: 4.7,
            reviewsCount: 89,
            price: 150000,
            image: "https://images.unsplash.com/photo-1649750396712-e34431b1f4aa",
            imageAlt: "Elegant white wedding tent with draped fabric ceiling, crystal chandeliers, round tables with gold chairs, and floral centerpieces in outdoor garden setting",
            description: "Premium tent and decoration services for grand celebrations. We provide complete event setup including lighting, furniture, and stage arrangements.",
            location: "Andheri East",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543211",
            email: "info@royaltent.com",
            services: ["Tent Setup", "Stage Decoration", "Lighting Arrangements", "Furniture Rental", "Floral Decor"],
            reviews: [
                {
                    author: "Amit Patel",
                    rating: 5,
                    comment: "Transformed our venue into a magical space. The team was professional and punctual.",
                    date: "January 20, 2026"
                },
                {
                    author: "Sneha Reddy",
                    rating: 4,
                    comment: "Beautiful setup and good service. Minor delays but overall satisfied with the outcome.",
                    date: "January 10, 2026"
                }]

        },
        {
            id: 3,
            name: "Spice Garden Caterers",
            category: "Catering",
            rating: 4.8,
            reviewsCount: 234,
            price: 800,
            image: "https://images.unsplash.com/photo-1690951784638-1f9039d74a6c",
            imageAlt: "Elegant buffet spread with multiple Indian cuisine dishes in silver serving trays, colorful vegetables, garnished plates, and professional catering setup",
            description: "Multi-cuisine catering with authentic flavors and presentation. From traditional Indian to continental, we serve delicious food for all occasions.",
            location: "Powai",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543212",
            email: "orders@spicegarden.com",
            services: ["Indian Cuisine", "Continental Menu", "Live Counters", "Dessert Stations", "Beverage Service"],
            reviews: [
                {
                    author: "Kavita Singh",
                    rating: 5,
                    comment: "Food quality was exceptional! Guests couldn\'t stop praising the taste and variety.",
                    date: "February 1, 2026"
                },
                {
                    author: "Vikram Joshi",
                    rating: 5,
                    comment: "Professional service and delicious food. The live counters were a big hit at our event.",
                    date: "January 25, 2026"
                }]

        },
        {
            id: 4,
            name: "Beats & Rhythm DJ",
            category: "DJ",
            rating: 4.6,
            reviewsCount: 67,
            price: 35000,
            image: "https://images.unsplash.com/photo-1612363007885-0aa242c4707d",
            imageAlt: "Professional DJ performing at wedding reception with turntables, mixing console, colorful LED lights, and crowd dancing in background",
            description: "High-energy DJ services with latest sound systems and lighting. We create the perfect party atmosphere with curated playlists and live mixing.",
            location: "Juhu",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543213",
            email: "bookings@beatsrhythm.com",
            services: ["DJ Services", "Sound System", "LED Lighting", "Fog Machines", "Custom Playlists"],
            reviews: [
                {
                    author: "Rohan Kapoor",
                    rating: 5,
                    comment: "Amazing energy throughout the night! The DJ knew exactly what songs to play.",
                    date: "January 30, 2026"
                },
                {
                    author: "Neha Gupta",
                    rating: 4,
                    comment: "Good music selection and professional setup. Would recommend for parties.",
                    date: "January 18, 2026"
                }]

        },
        {
            id: 5,
            name: "Glamour Makeup Studio",
            category: "Makeup Artist",
            rating: 4.9,
            reviewsCount: 178,
            price: 18000,
            image: "https://images.unsplash.com/photo-1619873460067-e68efce73719",
            imageAlt: "Professional makeup artist applying bridal makeup on bride with makeup brushes, cosmetics palette, and ring light in modern studio setting",
            description: "Bridal and party makeup by certified professionals. We use premium products and techniques to create stunning looks that last all day.",
            location: "Colaba",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543214",
            email: "bookings@glamourstudio.com",
            services: ["Bridal Makeup", "Party Makeup", "Hair Styling", "Saree Draping", "Pre-Wedding Trials"],
            reviews: [
                {
                    author: "Anjali Desai",
                    rating: 5,
                    comment: "Made me look absolutely gorgeous on my wedding day! Professional and talented team.",
                    date: "February 2, 2026"
                },
                {
                    author: "Pooja Iyer",
                    rating: 5,
                    comment: "Best makeup artist in Mumbai! The makeup stayed perfect throughout the event.",
                    date: "January 28, 2026"
                }]

        },
        {
            id: 6,
            name: "Lens & Light Photography",
            category: "Photography",
            rating: 4.8,
            reviewsCount: 142,
            price: 30000,
            image: "https://images.unsplash.com/photo-1685459494112-0a3199407594",
            imageAlt: "Wedding photographer capturing couple\'s romantic moment during sunset with professional camera equipment and golden hour lighting",
            description: "Creative wedding photography with artistic vision. We blend traditional and contemporary styles to create timeless memories.",
            location: "Worli",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543215",
            email: "hello@lenslight.com",
            services: ["Wedding Photography", "Engagement Shoots", "Videography", "Photo Editing", "Same Day Edit"],
            reviews: [
                {
                    author: "Sanjay Kumar",
                    rating: 5,
                    comment: "Incredible attention to detail. Every photo tells a beautiful story.",
                    date: "January 22, 2026"
                },
                {
                    author: "Meera Shah",
                    rating: 4,
                    comment: "Great photography skills and friendly team. Very satisfied with the results.",
                    date: "January 12, 2026"
                }]

        },
        {
            id: 7,
            name: "Grand Events Tent",
            category: "Tent House",
            rating: 4.5,
            reviewsCount: 56,
            price: 120000,
            image: "https://images.unsplash.com/photo-1649750396712-e34431b1f4aa",
            imageAlt: "Large outdoor wedding tent with transparent sides, string lights, wooden flooring, elegant table settings, and floral arrangements for evening reception",
            description: "Complete event management with premium tent solutions. We handle everything from setup to teardown with professional expertise.",
            location: "Goregaon",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543216",
            email: "contact@grandevents.com",
            services: ["Tent Installation", "Event Planning", "Decor Setup", "Audio Visual", "Seating Arrangements"],
            reviews: [
                {
                    author: "Rajesh Verma",
                    rating: 5,
                    comment: "Excellent service and beautiful setup. Made our event truly memorable.",
                    date: "January 27, 2026"
                },
                {
                    author: "Divya Nair",
                    rating: 4,
                    comment: "Professional team with good quality equipment. Recommended for large events.",
                    date: "January 16, 2026"
                }]

        },
        {
            id: 8,
            name: "Taste of India Catering",
            category: "Catering",
            rating: 4.7,
            reviewsCount: 198,
            price: 750,
            image: "https://images.unsplash.com/photo-1532421848714-6500b62673f8",
            imageAlt: "Traditional Indian thali with multiple curry dishes, rice, naan bread, salad, and dessert arranged on banana leaf with decorative presentation",
            description: "Authentic Indian cuisine with regional specialties. Our chefs bring traditional flavors with modern presentation to your events.",
            location: "Malad",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543217",
            email: "info@tasteofindia.com",
            services: ["North Indian", "South Indian", "Chaat Counter", "Dessert Bar", "Custom Menus"],
            reviews: [
                {
                    author: "Arun Pillai",
                    rating: 5,
                    comment: "Authentic taste and excellent service. Guests loved the variety of dishes.",
                    date: "February 3, 2026"
                },
                {
                    author: "Lakshmi Rao",
                    rating: 5,
                    comment: "Best catering service we\'ve used. Food was fresh and delicious.",
                    date: "January 29, 2026"
                }]

        },
        {
            id: 9,
            name: "Party Vibes DJ",
            category: "DJ",
            rating: 4.8,
            reviewsCount: 91,
            price: 40000,
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_1df1bfefe-1767505244511.png",
            imageAlt: "DJ booth with professional mixing equipment, colorful laser lights, smoke effects, and energetic crowd dancing at night party",
            description: "Premium DJ entertainment with state-of-the-art equipment. We specialize in creating unforgettable party experiences with perfect music flow.",
            location: "Lower Parel",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543218",
            email: "book@partyvibes.com",
            services: ["Professional DJ", "Premium Sound", "Lighting Effects", "Karaoke Setup", "MC Services"],
            reviews: [
                {
                    author: "Karan Malhotra",
                    rating: 5,
                    comment: "Best DJ in town! Kept the energy high throughout the entire event.",
                    date: "January 31, 2026"
                },
                {
                    author: "Simran Kaur",
                    rating: 5,
                    comment: "Fantastic music selection and professional service. Highly recommended!",
                    date: "January 24, 2026"
                }]

        },
        {
            id: 10,
            name: "Beauty Bliss Makeup",
            category: "Makeup Artist",
            rating: 4.7,
            reviewsCount: 134,
            price: 15000,
            image: "https://images.unsplash.com/photo-1516857251072-0887e81040de",
            imageAlt: "Makeup artist working on bride's face with professional brushes, cosmetics, and mirror in well-lit bridal preparation room",
            description: "Professional bridal and party makeup services. We create customized looks that enhance your natural beauty and match your style.",
            location: "Versova",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543219",
            email: "info@beautybliss.com",
            services: ["Bridal Makeup", "Engagement Makeup", "Hair Styling", "Mehendi Application", "Makeup Trials"],
            reviews: [
                {
                    author: "Riya Chopra",
                    rating: 5,
                    comment: "Amazing makeup artist! Made me feel like a princess on my special day.",
                    date: "February 4, 2026"
                },
                {
                    author: "Tanvi Jain",
                    rating: 4,
                    comment: "Good quality products and skilled application. Very satisfied with the service.",
                    date: "January 26, 2026"
                }]

        },
        {
            id: 11,
            name: "Capture Moments Studio",
            category: "Photography",
            rating: 4.6,
            reviewsCount: 87,
            price: 28000,
            image: "https://images.unsplash.com/photo-1695139417491-17cd9a619e27",
            imageAlt: "Wedding photographer capturing bride and groom's first dance with professional camera, flash equipment, and romantic venue lighting",
            description: "Contemporary wedding photography with emotional storytelling. We capture genuine moments and create beautiful visual narratives.",
            location: "Kandivali",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543220",
            email: "bookings@capturemoments.com",
            services: ["Wedding Coverage", "Pre-Wedding Shoots", "Candid Photography", "Photo Albums", "Digital Delivery"],
            reviews: [
                {
                    author: "Arjun Shetty",
                    rating: 5,
                    comment: "Captured every special moment beautifully. Professional and creative team.",
                    date: "January 21, 2026"
                },
                {
                    author: "Priyanka Das",
                    rating: 4,
                    comment: "Good photography and timely delivery. Recommended for weddings.",
                    date: "January 14, 2026"
                }]

        },
        {
            id: 12,
            name: "Elite Tent Solutions",
            category: "Tent House",
            rating: 4.9,
            reviewsCount: 72,
            price: 180000,
            image: "https://images.unsplash.com/photo-1702026008047-a3546b698322",
            imageAlt: "Luxurious wedding tent with white draped ceiling, crystal chandeliers, elegant table settings, gold chairs, and sophisticated lighting design",
            description: "Luxury tent and event setup services. We create stunning venues with premium materials and elegant designs for unforgettable celebrations.",
            location: "Vile Parle",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543221",
            email: "info@elitetent.com",
            services: ["Premium Tents", "Luxury Decor", "Stage Design", "Lighting Setup", "Complete Event Management"],
            reviews: [
                {
                    author: "Manish Agarwal",
                    rating: 5,
                    comment: "Absolutely stunning setup! Exceeded our expectations in every way.",
                    date: "February 2, 2026"
                },
                {
                    author: "Shruti Bansal",
                    rating: 5,
                    comment: "Top-notch service and beautiful execution. Worth every penny!",
                    date: "January 23, 2026"
                }]

        },
        {
            id: 13,
            name: "Flavors Catering Co",
            category: "Catering",
            rating: 4.8,
            reviewsCount: 167,
            price: 850,
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f187b2ec-1766600885350.png",
            imageAlt: "Gourmet catering display with variety of appetizers, main courses, salads, and desserts arranged on elegant serving platters with garnishes",
            description: "Premium catering with fusion and international cuisines. Our expert chefs create memorable dining experiences with innovative menus.",
            location: "Churchgate",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543222",
            email: "orders@flavorscatering.com",
            services: ["Fusion Cuisine", "International Menu", "Live Cooking", "Cocktail Service", "Themed Buffets"],
            reviews: [
                {
                    author: "Deepak Yadav",
                    rating: 5,
                    comment: "Exceptional food quality and presentation. Guests were thoroughly impressed.",
                    date: "January 30, 2026"
                },
                {
                    author: "Nisha Pandey",
                    rating: 5,
                    comment: "Creative menu and excellent service. Highly recommend for upscale events.",
                    date: "January 19, 2026"
                }]

        },
        {
            id: 14,
            name: "Rhythm Nation DJ",
            category: "DJ",
            rating: 4.7,
            reviewsCount: 103,
            price: 38000,
            image: "https://images.unsplash.com/photo-1637431621742-83933dc18c94",
            imageAlt: "DJ performing at outdoor wedding with professional turntables, speakers, colorful stage lights, and guests enjoying music under evening sky",
            description: "Professional DJ services with versatile music selection. We read the crowd and create the perfect atmosphere for your celebration.",
            location: "Dadar",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543223",
            email: "bookings@rhythmnation.com",
            services: ["DJ Entertainment", "Sound Systems", "Stage Lighting", "Wireless Mics", "Music Curation"],
            reviews: [
                {
                    author: "Varun Khanna",
                    rating: 5,
                    comment: "Fantastic DJ who kept everyone dancing all night. Great music mix!",
                    date: "February 1, 2026"
                },
                {
                    author: "Ishita Saxena",
                    rating: 4,
                    comment: "Professional service and good equipment. Everyone enjoyed the music.",
                    date: "January 17, 2026"
                }]

        },
        {
            id: 15,
            name: "Radiance Makeup Artistry",
            category: "Makeup Artist",
            rating: 4.9,
            reviewsCount: 156,
            price: 20000,
            image: "https://images.unsplash.com/photo-1653127636818-cf9c98233ff5",
            imageAlt: "Professional makeup artist applying finishing touches to bride's makeup with high-end cosmetics, brushes, and professional lighting in luxury studio",
            description: "Celebrity makeup artist specializing in bridal looks. We create flawless, camera-ready makeup that lasts throughout your special day.",
            location: "Bandra East",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543224",
            email: "contact@radiancemakeup.com",
            services: ["Bridal Makeup", "HD Makeup", "Airbrush Makeup", "Hair Styling", "Makeup Consultation"],
            reviews: [
                {
                    author: "Aditi Sharma",
                    rating: 5,
                    comment: "Best makeup artist ever! Made me look stunning and the makeup lasted all day.",
                    date: "February 3, 2026"
                },
                {
                    author: "Kritika Menon",
                    rating: 5,
                    comment: "Absolutely loved my bridal look! Professional and talented artist.",
                    date: "January 25, 2026"
                }]

        }];


    const handleCategoryChange = (categoryId) => {
        navigate('/service-listing-screen', { state: { category: categoryId } });
    };

    const handleVendorClick = (vendor) => {
        setSelectedVendor(vendor);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setTimeout(() => setSelectedVendor(null), 300);
    };

    return (
        <div className="min-h-screen bg-background pb-20">
            {/* Header */}
            <header className="sticky top-0 z-30 bg-card border-b border-border">
                <div className="content-container py-3 md:py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2 md:gap-3">
                            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary">
                                <Icon name="Sparkles" size={24} color="white" strokeWidth={2.5} />
                            </div>
                            <div>
                                <h1 className="text-lg md:text-xl font-heading font-semibold text-foreground">Infinite Studio

                                </h1>
                                <p className="text-xs md:text-sm text-muted-foreground font-caption">
                                    Find Your Perfect Vendor
                                </p>
                            </div>
                        </div>
                        <LocationSelector />
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="content-container section-spacing">
                {/* Hero Slider */}
                <HeroSlider />

                {/* Category Filter */}
                <div className="mt-8 md:mt-12 lg:mt-16">
                    <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-4 md:mb-6 px-4 md:px-0">
                        Browse by Category
                    </h2>
                    <CategoryFilter onCategoryChange={handleCategoryChange} />
                </div>

                {/* Trending Vendors */}
                <div className="mt-12 md:mt-16 lg:mt-24">
                    <TrendingSection
                        vendors={servicesData}
                        onVendorClick={handleVendorClick} />
                </div>

            </main>

            {/* Bottom Navigation */}
            <BottomTabNavigation />

            {/* Vendor Detail Modal */}
            <VendorDetailModal
                vendor={selectedVendor}
                isOpen={isModalOpen}
                onClose={handleCloseModal} />

        </div>);

};

export default HomeScreen;